// extracted by mini-css-extract-plugin
export default {"l":"_4939777cdb"};